<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <v-card-text class="pa-4">
        <div class="modal-body">
          <v-container fluid class="pa-0">
            <div class="font-weight-bold mb-3">
              本ルールを保存します。よろしいですか？
            </div>
            <v-table density="compact">
              <thead class="v-table-head text-caption">
                <tr>
                  <th>ID</th>
                  <th>送信元アドレス</th>
                  <th>宛先アドレス</th>
                  <th>サービス</th>
                  <th>アクション</th>
                  <th>有効/無効</th>
                  <th>備考</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ policy.policyId }}</td>
                  <td>
                    <intranet-policy-src-address
                      :ip-address-list="policy.srcAddressList"
                    />
                  </td>
                  <td>
                    <intranet-policy-dst-address
                      :ip-address-list="policy.dstAddressList"
                    />
                  </td>
                  <td>
                    <intranet-policy-service
                      :default-service-list="policy.serviceList"
                      :custom-service-list="policy.customServiceList"
                    />
                  </td>
                  <td>
                    {{ $filter.enumTo(policy.actionType, "allow_deny") }}
                  </td>
                  <td>
                    {{ $filter.enumTo(policy.isPolicyStatus, "enable") }}
                  </td>
                  <td class="text-pre-wrap">
                    {{ $filter.emptyTo(policy.description, "-") }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn color="primary" variant="flat" @click="ok">はい</v-btn>
            <v-btn color="primary" variant="outlined" @click="cancel">
              いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import IntranetPolicySrcAddress from "@/components/policy/IntranetPolicySrcAddress.vue";
import IntranetPolicyDstAddress from "@/components/policy/IntranetPolicyDstAddress.vue";
import IntranetPolicyService from "@/components/policy/IntranetPolicyService.vue";
import type { IntraPolicy } from "@/apis/IntranetfwPolicyApi";

/** イントラネットFW・PFGW共通の確認モーダル */
export default defineComponent({
  name: "IntranetFwPolicyRuleConfirm",
  components: {
    IntranetPolicySrcAddress,
    IntranetPolicyDstAddress,
    IntranetPolicyService,
  },
  props: {
    /** ポリシー
     * customServiceListの型はCustomServiceIntranetにある必要 */
    policy: {
      type: Object as PropType<IntraPolicy>,
      required: true,
    },
  },
});
</script>
<style lang="scss" scoped>
th {
  text-align: center !important;
}
</style>
